import { mbSize, Media } from '@foxrenderfarm/common'
import styled from 'styled-components'

export const ChatWrapper = styled.div<{ $hiddenInPC?: boolean }>`
  display: ${({ $hiddenInPC }) => ($hiddenInPC ? 'none' : 'block')};
  width: 1200px;
  height: 300px;
  position: relative;
  z-index: 0;
  margin-bottom: 100px;
  border-radius: 10px;
  overflow: hidden;
  ${Media.lessThan(Media.small)} {
    display: block;
    width: ${mbSize(670)};
    height: ${mbSize(640)};
    border-radius: ${mbSize(15)};
    margin-bottom: ${mbSize(160)};
  }
`

export const ChatContent = styled.div`
  margin: 55px 0 0 60px;
  ${Media.lessThan(Media.small)} {
    margin: ${mbSize(60)} 0 0 ${mbSize(40)};
  }
`

export const ChatTitle = styled.div`
  width: 433px;
  font-size: 40px;
  font-weight: 800;
  color: #333333;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(60)};
    width: ${mbSize(528)};
  }
`

export const ChatDesc = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 4px;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(8)};
    width: ${mbSize(564)};
    font-size: ${mbSize(28)};
  }
`

export const Button = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  height: 36px;
  width: 264px;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  background: #f3512b;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.3s;
  svg {
    transition: all 0.3s;
    margin-left: 10px;
  }
  &:hover {
    box-shadow: 0px 8px 14px 0px rgba(243, 81, 43, 0.4);
    svg {
      margin-left: 20px;
    }
  }
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(40)};
    padding-left: ${mbSize(46)};
    height: ${mbSize(54)};
    width: ${mbSize(400)};
    font-size: ${mbSize(24)};
    svg {
      width: ${mbSize(24)};
      height: ${mbSize(24)};
      margin-left: ${mbSize(11)};
      &:hover {
        svg {
          margin-left: ${mbSize(20)};
        }
      }
    }
  }
`
